import * as tslib_1 from "tslib";
import { lazyInitializeExtensibilityContext } from 'owa-addins-core';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { action } from 'satcheljs/lib/legacy';
export default action('initializeExtensibilityContext')(function initializeExtensibilityContext() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Initializing the EXT context here is only needed for addins.
                    if (!isMailFeatureEnabled('rp-addins')) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, lazyInitializeExtensibilityContext.import()];
                case 1: 
                // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                return [4 /*yield*/, (_a.sent())()];
                case 2:
                    // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeExtensibilityContext.js.map